/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import HotelStrategyStrategyDetailWithTabsBaseController from 'lumen/controllers/hotel/strategy/strategy-detail-with-tabs-base';
import { DAY_OF_WEEK_TRANSLATIONS } from 'lumen/utils/constants/general-constants';
import {
  COLUMN_PROPERTIES,
  TYPE_ID_DOW,
} from 'lumen/utils/constants/rate-strategy-constants';
import { formatTableRate } from 'lumen/utils/strategy/detail-view-helpers';
import { timeout } from 'lumen/utils/waiters';

export default class HotelStrategyDowController extends HotelStrategyStrategyDetailWithTabsBaseController {
  @service('hotel-and-market') hotelAndMarketService;
  @service intl;
  @service simpleExport;

  typeId = TYPE_ID_DOW;

  exportRSTableTask = task({ drop: true }, async () => {
    const sheetName =
      this.typesDataPerId[this.typeId].formattedTypeName.toString();

    const headers = [this.intl.t('general.hotels').toString()];

    this.subtypes.forEach((subtype) => {
      headers.push(
        this.intl.t(DAY_OF_WEEK_TRANSLATIONS[subtype.label]).toString(),
      );
    });

    const content = [];
    this.dowDataPerHotelInfo.forEach((rowObject) => {
      const row = [rowObject[COLUMN_PROPERTIES.HOTELINFO].formattedValue];

      this.subtypes.forEach((subtype) => {
        row.push(
          formatTableRate(rowObject[subtype.id][COLUMN_PROPERTIES.RATE]),
        );
      });

      content.push(row);
    });

    const postData = JSON.stringify({ headers, content, sheetName });
    this.simpleExport.execute(postData, this.hotelAndMarketService.hotel?.id);

    // Add a cooldown before the export can be triggered again
    // Prevents multiple downloads on double click or worse: Chrome disabling downloads from mylighthouse.com
    await timeout();
  });

  @computed('hasRSData', 'selectedCompetitors', 'subtypes', 'typesDataPerId')
  get dowDataPerHotelInfo() {
    const dowDataPerHotelInfo = new Map();

    if (this.hasRSData) {
      // Initialize the Map keys (only performed once in this entire loop)
      this.selectedCompetitors.forEach((hotelinfo) => {
        const tableColumns = {
          [COLUMN_PROPERTIES.HOTELINFO]: {
            id: hotelinfo.id,
            formattedValue: hotelinfo.name,
            isOwnHotelInfo:
              this.hotelAndMarketService.isOwnHotelInfo(hotelinfo),
          },
        };

        // Add a dummy object for each subtype (corresponds to a grouped column in the detail view)
        this.subtypes.forEach((subtype) => {
          tableColumns[subtype.id] = {};
        });

        dowDataPerHotelInfo.set(hotelinfo.id, tableColumns);
      });

      this.subtypes.forEach((subtype) => {
        subtype.filteredPatterns.forEach((pattern) => {
          dowDataPerHotelInfo.get(pattern.hotelinfo.id)[subtype.id][
            COLUMN_PROPERTIES.RATE
          ] = {
            value: pattern.rate,
            formattedValue: pattern.formattedRate,
            baserate: pattern.rsbaserate,
            hasNoData: pattern.hasNoData,
            subsortOrder: pattern.subsortOrder,
          };
        });
      });
    }

    return dowDataPerHotelInfo;
  }
}
